/* ==========================================================================
   Samaná — Página de producto Gafas Blueblockers
   Al elegir Filtro y Marco cambian: fotos, precio, cuotas, descripción corta
   y la ficha larga desplegable.
   ========================================================================== */
(function () {
  'use strict';

  function iniciar(raiz) {
    if (!raiz || raiz.__pgListo) return;
    raiz.__pgListo = true;

    var datos = raiz.querySelector('[data-pg-variantes]');
    if (!datos) return;

    var variantes;
    try { variantes = JSON.parse(datos.textContent); } catch (e) { return; }
    if (!variantes.length) return;

    var chipsFiltro = Array.prototype.slice.call(raiz.querySelectorAll('[data-pg-filtro]'));
    var chipsMarco = Array.prototype.slice.call(raiz.querySelectorAll('[data-pg-marco]'));
    var thumbs = Array.prototype.slice.call(raiz.querySelectorAll('[data-pg-thumb]'));
    var principal = raiz.querySelector('[data-pg-main]');
    var video = raiz.querySelector('[data-pg-video]');
    var contenedorPrincipal = raiz.querySelector('.sm-pg__main');
    var campoId = raiz.querySelector('[data-pg-id]');
    var boton = raiz.querySelector('[data-pg-cta]');
    var despacho = raiz.querySelector('[data-pg-despacho]');

    // Arranca en la variante que el producto trae seleccionada, o la primera con stock.
    var inicial = variantes.filter(function (v) { return v.disponible; })[0] || variantes[0];
    if (campoId && campoId.value) {
      var porUrl = variantes.filter(function (v) { return String(v.id) === String(campoId.value); })[0];
      if (porUrl) inicial = porUrl;
    }

    // Si llegaron desde la portada con ?filtro=Amarillas, arrancar en ese filtro.
    // Se usa el nombre y no el id de variante para que siga funcionando aunque
    // más adelante se cambien, agreguen o borren variantes.
    try {
      var pedido = new URLSearchParams(window.location.search).get('filtro');
      if (pedido) {
        var normalizar = function (s) {
          // Comparar sin mayusculas ni espacios sobrantes alcanza:
          // los filtros (Amarillas, Naranjas, Rojas) no llevan acentos.
          return String(s).trim().toLowerCase();
        };
        var delFiltro = variantes.filter(function (v) {
          return normalizar(v.filtro) === normalizar(pedido);
        });
        if (delFiltro.length) {
          inicial = delFiltro.filter(function (v) { return v.disponible; })[0] || delFiltro[0];
        }
      }
    } catch (e) { /* navegador viejo: se ignora y arranca normal */ }

    var estado = { filtro: inicial.filtro, marco: inicial.marco };
    var visibles = [];
    var indiceFoto = 0;

    function buscarVariante(filtro, marco) {
      return variantes.filter(function (v) {
        return v.filtro === filtro && v.marco === marco;
      })[0];
    }

    function marcosDe(filtro) {
      return variantes.filter(function (v) { return v.filtro === filtro; });
    }

    // ---------- Fotos ----------

    function calcularVisibles() {
      var exactas = thumbs.filter(function (t) {
        return t.dataset.filtro === estado.filtro && t.dataset.marco === estado.marco;
      });
      var delFiltro = thumbs.filter(function (t) {
        return t.dataset.filtro === estado.filtro && !t.dataset.marco;
      });
      // Material general: va SIEMPRE y al final. Son las piezas sin combinación
      // y los videos (el video es uno solo y vale para todos los modelos, así que
      // se incluye aunque alguien le ponga texto alternativo desde el panel).
      var generales = thumbs.filter(function (t) {
        return t.dataset.tipo === 'video' || !t.dataset.filtro;
      });

      var lista = exactas.concat(delFiltro).concat(generales);
      if (!lista.length) lista = thumbs.slice();
      return lista;
    }

    function mostrarFoto(i, animar) {
      if (!visibles.length || !principal) return;
      indiceFoto = (i + visibles.length) % visibles.length;
      var destino = visibles[indiceFoto];
      var url = destino.dataset.full;

      thumbs.forEach(function (t) { t.setAttribute('aria-current', t === destino ? 'true' : 'false'); });

      // ---- Si lo elegido es el video, se muestra el reproductor en vez de la foto ----
      if (destino.dataset.tipo === 'video' && video) {
        principal.hidden = true;
        video.hidden = false;
        var fuente = destino.dataset.video || '';
        if (video.getAttribute('src') !== fuente) {
          video.setAttribute('src', fuente);
          video.setAttribute('poster', url);
        }
        return;
      }

      if (video && !video.hidden) {
        try { video.pause(); } catch (e) { /* si no arrancó, no importa */ }
        video.hidden = true;
      }
      principal.hidden = false;

      if (principal.getAttribute('src') === url) return;

      if (animar && contenedorPrincipal) {
        contenedorPrincipal.classList.add('is-cambiando');
        var previa = new Image();
        previa.onload = function () {
          principal.src = url;
          principal.alt = destino.querySelector('img') ? destino.querySelector('img').alt : '';
          contenedorPrincipal.classList.remove('is-cambiando');
        };
        previa.onerror = function () { contenedorPrincipal.classList.remove('is-cambiando'); };
        previa.src = url;
      } else {
        principal.src = url;
      }
    }

    function refrescarGaleria(animar) {
      visibles = calcularVisibles();
      thumbs.forEach(function (t) { t.hidden = visibles.indexOf(t) === -1; });

      var nav = raiz.querySelectorAll('[data-pg-prev], [data-pg-next]');
      Array.prototype.forEach.call(nav, function (b) { b.hidden = visibles.length < 2; });

      mostrarFoto(0, animar);
    }

    // ---------- Aviso de despacho ----------

    function refrescarDespacho() {
      if (!despacho) return;
      var corte = parseInt(raiz.dataset.horaCorte || '15', 10);
      var horaLocal;
      try {
        horaLocal = parseInt(new Intl.DateTimeFormat('es-AR', {
          timeZone: 'America/Argentina/Buenos_Aires', hour: 'numeric', hour12: false
        }).format(new Date()), 10);
      } catch (e) {
        horaLocal = new Date().getHours();
      }

      var restantes = corte - horaLocal;
      if (restantes > 0) {
        despacho.textContent = (despacho.dataset.plantilla || '').replace('{h}', restantes);
      } else {
        despacho.textContent = despacho.dataset.plantillaTarde || '';
      }
      despacho.hidden = !despacho.textContent;
    }

    // ---------- Pintar todo ----------

    function pintar(animar) {
      var v = buscarVariante(estado.filtro, estado.marco);
      if (!v) {
        var alternativa = marcosDe(estado.filtro)[0];
        if (!alternativa) return;
        estado.marco = alternativa.marco;
        v = alternativa;
      }

      // Chips de filtro
      chipsFiltro.forEach(function (c) {
        c.setAttribute('aria-checked', c.dataset.pgFiltro === estado.filtro ? 'true' : 'false');
      });

      // Chips de marco: solo los del filtro elegido
      chipsMarco.forEach(function (c) {
        var esDeEsteFiltro = c.dataset.pgDeFiltro === estado.filtro;
        c.hidden = !esDeEsteFiltro;
        c.setAttribute('aria-checked', esDeEsteFiltro && c.dataset.pgMarco === estado.marco ? 'true' : 'false');
      });

      // Textos que dependen del filtro o del marco
      Array.prototype.forEach.call(raiz.querySelectorAll('[data-pg-when-filtro]'), function (el) {
        el.hidden = el.dataset.pgWhenFiltro !== estado.filtro;
      });
      Array.prototype.forEach.call(raiz.querySelectorAll('[data-pg-when-marco]'), function (el) {
        el.hidden = el.dataset.pgWhenMarco !== estado.marco;
      });

      // Precios
      var lista = raiz.querySelector('[data-pg-lista]');
      var transfer = raiz.querySelector('[data-pg-transfer]');
      var offWrap = raiz.querySelector('[data-pg-off-wrap]');
      var off = raiz.querySelector('[data-pg-off]');
      var badge = raiz.querySelector('[data-pg-badge]');
      var cuotas = raiz.querySelector('[data-pg-cuotas]');

      if (transfer) transfer.textContent = v.transfer;
      if (lista) {
        lista.textContent = v.lista;
        lista.hidden = v.off <= 0;
      }
      if (offWrap) offWrap.hidden = v.off <= 0;
      if (off) off.textContent = (off.dataset.plantilla || '{off}% de descuento').replace('{off}', v.off);
      if (badge) {
        badge.textContent = (badge.dataset.plantilla || '-{off}%').replace('{off}', v.off);
        badge.hidden = v.off <= 0;
      }
      if (cuotas) cuotas.textContent = (cuotas.dataset.plantilla || '').replace('{cuota}', v.cuota);

      // Compra
      if (campoId) campoId.value = v.id;
      if (boton) {
        boton.disabled = !v.disponible;
        boton.textContent = v.disponible
          ? (boton.dataset.label || 'Comprar')
          : (boton.dataset.labelAgotado || 'Sin stock');
      }
      if (despacho) despacho.hidden = !v.disponible;

      refrescarGaleria(animar);

      // Dejar la variante en la dirección web, para poder compartir el enlace exacto
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
      } catch (e) { /* si el navegador no deja, no pasa nada */ }
    }

    // ---------- Eventos ----------

    chipsFiltro.forEach(function (c) {
      c.addEventListener('click', function () {
        if (c.dataset.pgFiltro === estado.filtro) return;
        estado.filtro = c.dataset.pgFiltro;

        // Se intenta conservar el mismo marco; si ese filtro no lo tiene, va el primero con stock.
        var deEsteFiltro = marcosDe(estado.filtro);
        var mismo = deEsteFiltro.filter(function (v) { return v.marco === estado.marco; })[0];
        if (!mismo) {
          var conStock = deEsteFiltro.filter(function (v) { return v.disponible; })[0];
          estado.marco = (conStock || deEsteFiltro[0]).marco;
        }
        pintar(true);
      });
    });

    chipsMarco.forEach(function (c) {
      c.addEventListener('click', function () {
        if (c.dataset.agotado === 'true') return;
        estado.marco = c.dataset.pgMarco;
        pintar(true);
      });
    });

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = visibles.indexOf(t);
        if (i !== -1) mostrarFoto(i, true);
      });
    });

    var btnPrev = raiz.querySelector('[data-pg-prev]');
    var btnNext = raiz.querySelector('[data-pg-next]');
    if (btnPrev) btnPrev.addEventListener('click', function () { mostrarFoto(indiceFoto - 1, true); });
    if (btnNext) btnNext.addEventListener('click', function () { mostrarFoto(indiceFoto + 1, true); });

    // Desplegable de la descripción
    var accBtn = raiz.querySelector('[data-pg-acc-btn]');
    var accBody = raiz.querySelector('[data-pg-acc-body]');
    if (accBtn && accBody) {
      accBtn.addEventListener('click', function () {
        var abierto = accBtn.getAttribute('aria-expanded') === 'true';
        accBtn.setAttribute('aria-expanded', abierto ? 'false' : 'true');
        accBody.classList.toggle('is-abierto', !abierto);
      });
    }

    refrescarDespacho();
    pintar(false);
  }

  function arrancar() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-sm-pg]'), iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }

  // El editor de Shopify vuelve a dibujar la sección al cambiar un ajuste.
  document.addEventListener('shopify:section:load', function (e) {
    var raiz = e.target.querySelector('[data-sm-pg]');
    if (raiz) iniciar(raiz);
  });
})();
